import axios from 'axios';
import { convertor } from './messageConvertor';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL,
});
axiosInstance.interceptors.response.use((response) => convertor(response.data));

export default axiosInstance;
